module.exports = __webpack_public_path__ + "img/step-completed-icon.svg";